module.exports = __webpack_public_path__ + "img/Twitter_Logo_Blue.fef946b8.png";